import { makeStyles } from '@material-ui/core/styles';

export default makeStyles((theme) => ({
  card: {
    position: 'relative',
    borderRadius: 20,
    boxShadow: '2px 2px 6px 0 rgba(0, 0, 0, 0.2)',
    backgroundColor: ({ black }) => (black ? '#303030' : '#fff'),
    padding: '20px 10px',
    boxSizing: 'border-box',
    margin: '10px 0',
  },
  row: {
    display: 'flex',
    cursor: 'pointer',
  },
  row2: {
    display: 'flex',
    alignItems: 'center',
    marginTop: 3,
  },
  f1: {
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    marginRight: 5,
  },
  f2: {
    flex: 2,
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    marginLeft: 5,
  },

  title: {
    fontSize: 10,
    fontFamily: 'Averta Bold',
    fontWeight: 600,
    lineHeight: 1.3,
    color: ({ black }) => (black ? '#fff' : '#303030'),
  },
  light: {
    fontSize: 10,
    fontFamily: 'Averta light',
    fontWeight: 300,
    color: ({ black }) => (black ? '#fff' : '#43424b'),
    wordBreak: 'break-all',
  },

  avatar: {
    height: 60,
    width: 60,
    marginBottom: 10,
  },
  icon: {
    height: 20,
    width: 20,
    fill: '#f8b100',
    margin: '0 5px',
  },

  seen: {
    display: 'flex',
    fontSize: 10,
    fontFamily: 'Averta light',
    fontWeight: 300,
    color: ({ black }) => (black ? '#fff' : '#43424b'),
    justifyContent: 'flex-end',
  },

  more: {
    position: 'absolute',
    right: 10,
    top: 10,
    height: 25,
    width: 20,
    color: ({ black }) => (black ? '#fff' : '#303030'),
    cursor: 'pointer',
  },
}));
